import React from 'react';

const MonthlyViewItem = ({ meeting, onClick }) => {
  const circleColor = meeting.textColor ? '' : 'text-slate-950';

  return (
    <div
      style={{ backgroundColor: meeting.backgroundColor, borderColor: meeting.borderColor }}
      className={`group relative w-full aspect-square max-w-9 flex items-center justify-center rounded-full border-2 ${circleColor} shadow-sm cursor-pointer hover:scale-110 transition-transform`}
      title={`${meeting.title} | ${meeting.time} - ${meeting.endTime}`}
      aria-label={`${meeting.title}، ${meeting.time} تا ${meeting.endTime}`}
      onClick={onClick}
    >
      <span style={{ color: meeting.textColor }} className={`text-xs font-black ${circleColor}`}>{meeting.title?.charAt(0) || '؟'}</span>
    </div>
  );
};

export default MonthlyViewItem;